<template>
  <div class="legislacao">
    <div class="container">
      <h1 class="display-1 my-3">WEBSERVICE LOTE - RPS</h1>
      <v-divider></v-divider>
      <v-layout wrap class="my-3">
        <v-flex xs12 sm9 class="mb-4 px-8">
          <p
            class="subtitle-2 grey--text"
          >Para os contribuintes que emitem uma grande quantidade de notas, foi criada a entrega de RPS em lote, no qual o contribuinte pode emitir Recibos Provisórios de Serviços (RPS) através de seus próprios sistemas e estes em um determinado momento, serão convertidos em notas fiscais. Para converter estes RPS em NFS-e o sistema do contribuinte deve se conectar ao Web Service da prefeitura e enviar as informações de RPS gerados no formato XML, gerando um lote de entrega.</p>
          <p class="headline">Integração de sistemas via Webservice</p>
          <p
            class="subtitle-2 grey--text"
          >Através do Web Service as empresas poderão integrar seus próprios sistemas de informações com o Sistema de NFS-e para automatizar o processo de emissão, consulta e processamento. Através do serviço, o Sistema de NFS-e disponibiliza uma série de funcionalidades que poderão ser acessadas pelos sistemas dos contribuintes.</p>
          <v-btn
            outlined
            small
            color="teal ligthen-1"
            :href="linkWebserviceProducao"
            target="_blank"
          >Acesso ao Webservice - Produção</v-btn>
          <v-btn
            outlined
            small
            class="ml-2"
            color="yellow darken-4"
            :href="linkWebserviceHomologacao"
            target="_blank"
          >Acesso ao Webservice - Homologação</v-btn>
        </v-flex>

        <v-flex xs12 sm3>
          <h2 class="title font-weight-font-weight-font-italic">Manual</h2>
          <v-divider></v-divider>
          <p
            class="grey--text body-2"
          >Baixe aqui o guia para a integração do sistema via Webservices.</p>
          <v-btn text small outlined :href="linkManualIntegracao" target="_blank">baixar</v-btn>
        </v-flex>
        <v-flex xs9 md9 class="mb-4 px-8">
          <h2 class="headline">Ajustes necessários para integração</h2>
          <v-card class="pa-2 mt-2">
            <v-card-text>
              <p
                class="subtitle-1 black--text"
              >1) Alterar o namespace do cabeçalho da requisição, da seguinte forma:</p>
              <p>
                De:
                <span
                  class="grey--text"
                >&lt;soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://homologacao.ginfes.com.br&gt;</span>
              </p>
              <p>
                Para:
                <span
                  class="black--text"
                >&lt;soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns="http://www.abrasf.org.br/nfse.xsd"&gt;</span>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs9 md9 class="mb-4 px-8">
          <v-card class="pa-2 mt-2">
            <v-card-text>
              <p
                class="subtitle-1 black--text"
              >2) Alterar o namespace dentro do XML enviado, da seguinte forma:</p>
              <p>
                De:
                <span
                  class="grey--text"
                >&lt;EnviarLoteRpsEnvio xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.ginfes.com.br/servico_enviar_lote_rps_envio_v03.xsd"&gt;</span>
              </p>
              <p>
                Para:
                <span
                  class="black--text"
                >&lt;EnviarLoteRpsEnvio xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http:/www.abrasf.org.br/nfse.xsd&gt;</span>
              </p>
              <p
                class="caption"
              >Observe que o exemplo acima é sobre o método EnviarLoteRpsEnvio, mas a alteração deve ser feita em todos os métodos, retirando as referências ao XSD da GINFES, e substituindo pelo XSD da ABRASF.</p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs9 md9 class="mb-4 px-8">
          <v-card class="pa-2 mt-2">
            <v-card-text>
              <p
                class="subtitle-1 black--text"
              >3) Excluir a referência a tipos_v03.xsd em todos os elementos, da seguinte forma:</p>
              <p>
                De:
                <span
                  class="grey--text"
                >&lt;InscricaoMunicipal xmlns="http://www.ginfes.com.br/tipos_v03.xsd"&gt;999999&lt;/InscricaoMunicipal&gt;</span>
              </p>
              <p>
                Para:
                <span
                  class="black--text"
                >&lt;InscricaoMunicipal&gt;999999&lt;/InscricaoMunicipal&gt;</span>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs9 md9 class="mb-4 px-8">
          <v-card class="pa-2 mt-2">
            <v-card-text>
              <p
                class="subtitle-1 black--text"
              >4) Alterar o elemento LoteRps adicionando o namespace, da seguinte forma:</p>
              <p>
                De:
                <span class="grey--text">&lt;LoteRps xmlns="http:/www.abrasf.org.br/nfse.xsd"&gt;</span>
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs9 md9 class="mb-4 px-8">
          <v-card class="pa-2 mt-2">
            <v-card-text>
              <p class="subtitle-1 black--text">5) Atividade x CNAE</p>
              <p
                class="grey--text"
              >Como a nova versão da Nota Fiscal utiliza CNAE ao invés do Código de Tributação do Município, o contribuinte poderá enviar a tag CodigoCnae preenchida. Caso não envie, o sistema fará um DE-PARA para preenchimento dessa informação.</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout></v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkManualIntegracao:
        "http://www.abrasf.org.br/arquivos/files/GT2-DES-IF/NFSe/NFSe1.0/NFSe_ManualDeIntegracao_2008dez29.pdf",
      linkWebserviceHomologacao: "",
      linkWebserviceProducao: ""
    };
  },
  methods: {
    baixarPDF() {
      let link = document.createElement("a");
      link.href = "/LC5.687, 20 DE DEZ 2021.pdf";
      link.download = "decretoNotaJoseense";
      link.click();
    }
  }
};
</script>
